<template>
  <div>
    <div class="policy">
      <div class="title d-lg-block">Ваш поліс</div>
      <hr class="d-none d-lg-block">

      <div class="specific d-lg-block">
        <b>Місце реєстрації</b>
        <p>{{ searchParams.countryId == 1 ? 'Україна' : 'Весь світ (за винятком України)' }}</p>
      </div>
      <div class="specific d-lg-block">
        <b>Термін дії</b>
        <p>{{ formatPeriod(searchParams.period) }}</p>
      </div>
      <div class="specific d-lg-block">
        <b>Початок дії договору</b>
        <p>{{ searchParams.startDate }}</p>
      </div>
      <div class="specific d-lg-block">
        <b>Період дії страхового захисту</b>
        <p>{{ formatProtectionPeriod(searchParams.protectionPeriod) }}</p>
      </div>
      <div class="specific d-lg-block">
        <b>Дата народження застрахованої особи</b>
        <p>{{ searchParams.birthDate }}</p>
      </div>
      <div class="specific d-lg-block">
        <b>Загальна страхова сума</b>
        <p>{{ searchParams.sum }} грн</p>
      </div>
      <div class="specific d-lg-block">
        <b>Фактори що впливають на фінальну вартість</b>
        <p>{{ activeFactorsText }}</p>
      </div>
      <div class="specific d-lg-block">
        <b>Страхові ризики</b>
        <p>{{ coveredRisksText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {AccentLightButton} from "@/shared/ui/form";
import {formatAccidentPeriod} from '@/views/accident/data/accidentPeriods';
import {formatCoveredRisksCount} from '@/views/accident/data/accidentRisks';

export default {
  name: 'AccidentPolicyInfo',
  components: {AccentLightButton},
  computed: {
    searchParams() {
      return this.$store.getters.GET_SEARCH_ACCIDENT_PARAMS || {};
    },
    activeFactorsText() {
      const factors = [];
      if (this.searchParams.warRisk) {
        factors.push('Воєнні ризики');
      }
      if (this.searchParams.sportType && this.searchParams.sportType !== 'none' && this.searchParams.sportType !== '140995') {
        factors.push('Спорт');
      }
      if (this.searchParams.profession && this.searchParams.profession !== 'none' && this.searchParams.profession !== '1412260') {
        factors.push('Професія');
      }
      if (factors.length === 0) {
        return 'Без підвищеного ризику';
      }
      return factors.join(', ');
    },
    coveredRisksText() {
      if (!this.searchParams) return 'Базові (всі)';
      const count = formatCoveredRisksCount(this.searchParams.accidentRisks || this.searchParams.accident || this.searchParams);
      return count ? `${count} обрано` : 'Базові (всі)';
    }
  },
  methods: {
    formatPeriod(period) {
      return formatAccidentPeriod(period);
    },
    formatProtectionPeriod(period) {
      if (!period || period === '24_7') return '24/7';
      if (period === 'study_work_hours' || period === 'working_hours') return 'Під час учбових занять / службових обов’язків';
      if (period === 'sport_hours') return 'Під час занять спортом/змагань';
      return period;
    }
  }
}
</script>
